import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

export interface IClinicWalletsActionProps {
  abc: string;
}

AxiosCurlirize(axios, () => {});

export const useAppoitmentStatusList = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [closureData, setClosureData] = useState<any>([]);

  const execute = useCallback(
    async (clinic_id: string, shift: string, API_OPERATION?: string, API_SOURCE?: string) => {
      dispatch(
        setLoading({
          key: "isClosingDataInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .get(
            `${DAY_CLOSING_APIS?.APPOITNTMENT_STATUS?.baseURL}${API_OPERATION}/reconciliation/${API_SOURCE}?clinic_ids=${clinic_id}&shift=${shift}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setClosureData(res.data.data);
              dispatch(
                setLoading({
                  key: "isClosingDataInProgress",
                  status: false,
                }),
              );
              return { status: true };
            } else {
              setClosureData([]);
              dispatch(
                setLoading({
                  key: "isClosingDataInProgress",
                  status: false,
                }),
              );
              //
            }
          })
          .catch((e: AxiosError) => {
            setClosureData([]);
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isClosingDataInProgress",
                status: false,
              }),
            );
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        setClosureData([]);
        captureError(e);
        dispatch(
          setLoading({
            key: "isClosingDataInProgress",
            status: false,
          }),
        );
      }
    },
    [dispatch],
  );
  return { execute, closureData };
};
